import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, ExternalLinkIcon } from 'lucide-react';
import { BUSINESS } from '../lib/structuredData';
interface OfficeAddressBlockProps {
  /** Optionele regel over afstand en reistijd tot een plaats. */
  travelNote?: string;
}

// Adresblok van ons kantoor. Zelfde gegevens als in de footer en het schema.
export const OfficeAddressBlock: React.FC<OfficeAddressBlockProps> = ({
  travelNote
}) => {
  return <div className="rounded-2xl border border-gray-200 bg-white p-7" data-id="element-526" data-mp="7ob9b9d4wfbj">
      <h3 className="font-bold text-[#111827] text-lg mb-1" data-id="element-527" data-mp="bov8sjl6jv0u">Ons kantoor</h3>
      <p className="text-sm text-[#6B7280] mb-5" data-id="element-528" data-mp="gmmz5966f92x">
        Oudkarspel, gemeente {BUSINESS.municipality}
      </p>
      <address className="not-italic" data-id="element-529" data-mp="lewx9chg3fga">
        <ul className="space-y-3.5 text-[#4B5563]" data-id="element-530" data-mp="lfy8pi2di3yj">
          <li className="flex items-start gap-3" data-id="element-531" data-mp="3k4nb0zeurylt">
            <MapPinIcon className="h-5 w-5 text-[#004AC7] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-532" data-mp="3k1so918da1p8" />
            <span data-id="element-533" data-mp="3p0lty7hewoeu">
              {BUSINESS.name}
              <br data-id="element-534" data-mp="1jtd8vz1rqequ" />
              {BUSINESS.street}
              <br data-id="element-535" data-mp="1jw961l5skze8" />
              {BUSINESS.postalCode} {BUSINESS.city}
            </span>
          </li>
          <li className="flex items-center gap-3" data-id="element-536" data-mp="1fv78r9vfqxew">
            <PhoneIcon className="h-5 w-5 text-[#004AC7] flex-shrink-0" aria-hidden="true" data-id="element-537" data-mp="1b0ti1krpxegk" />
            <a href={`tel:${BUSINESS.phone}`} className="hover:text-[#004AC7] transition-colors duration-200" data-id="element-538" data-mp="161ys7yvc2pmy">
              {BUSINESS.phoneDisplay}
            </a>
          </li>
          <li className="flex items-center gap-3" data-id="element-539" data-mp="w4c7gvrcs3v2">
            <MailIcon className="h-5 w-5 text-[#004AC7] flex-shrink-0" aria-hidden="true" data-id="element-540" data-mp="w3j0btohfcce" />
            <a href={`mailto:${BUSINESS.email}`} className="hover:text-[#004AC7] transition-colors duration-200" data-id="element-541" data-mp="s3il46tk6x4a">
              {BUSINESS.email}
            </a>
          </li>
          <li className="flex items-center gap-3" data-id="element-542" data-mp="2mg8biekpxo6x">
            <ClockIcon className="h-5 w-5 text-[#004AC7] flex-shrink-0" aria-hidden="true" data-id="element-543" data-mp="2hi6wq5ubsb19" />
            <span data-id="element-544" data-mp="2hgcb0pb8cew4">Maandag tot en met vrijdag, 9.00 tot 17.00 uur</span>
          </li>
        </ul>
      </address>
      {travelNote && <p className="mt-5 pt-5 border-t border-gray-100 text-sm text-[#6B7280] leading-relaxed" data-id="element-545" data-mp="35e1ut3tw1pb2">
          {travelNote}
        </p>}
      <a href={BUSINESS.mapsUrl} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#004AC7] hover:text-[#003A9E] transition-colors duration-200" data-id="element-546" data-mp="2rnesz2stzjar">
        Route in Google Maps
        <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-547" data-mp="3oce3ypksuz6n" />
      </a>
    </div>;
};